"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrenciesOnNetwork = exports.getCurrencyInfo = exports.ethCurrencyNameForNetwork = exports.commifiedRoundedNumberString = exports.numberStringRound = void 0;
const units_1 = require("@ethersproject/units");
const decimal_js_1 = require("decimal.js");
const network_1 = require("./network");
const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
const currencies = {
    APE: {
        coinGeckoId: 'apecoin',
        erc20: {
            [network_1.NETWORK_IDS.MAINNET]: {
                address: '0x4d224452801aced8b2f0aebe155379bb5d594381',
                decimals: 18,
            },
            [network_1.NETWORK_IDS.GOERLI]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.SEPOLIA]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.OPTIMISM]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.BASE]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.MATIC]: {
                address: undefined,
                decimals: 18,
            },
        },
        name: 'APE',
    },
    ASH: {
        coinGeckoId: 'ash',
        erc20: {
            [network_1.NETWORK_IDS.MAINNET]: {
                address: '0x64d91f12ece7362f91a6f8e7940cd55f05060b92',
                decimals: 18,
            },
            [network_1.NETWORK_IDS.GOERLI]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.SEPOLIA]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.OPTIMISM]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.BASE]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.MATIC]: {
                address: undefined,
                decimals: 18,
            },
        },
        name: 'ASH',
    },
    DAI: {
        coinGeckoId: 'dai',
        erc20: {
            [network_1.NETWORK_IDS.MAINNET]: {
                address: '0x6b175474e89094c44da98b954eedeac495271d0f',
                decimals: 18,
            },
            [network_1.NETWORK_IDS.GOERLI]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.SEPOLIA]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.OPTIMISM]: {
                address: '0xda10009cbd5d07dd0cecc66161fc93d7c9000da1',
                decimals: 18,
            },
            [network_1.NETWORK_IDS.BASE]: {
                address: '0x50c5725949a6f0c72e6c4a641f24049a917db0cb',
                decimals: 18,
            },
            [network_1.NETWORK_IDS.MATIC]: {
                address: undefined,
                decimals: 18,
            },
        },
        name: 'DAI',
    },
    ETH: {
        coinGeckoId: 'ethereum',
        erc20: {
            [network_1.NETWORK_IDS.MAINNET]: {
                address: ZERO_ADDRESS,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.GOERLI]: {
                address: ZERO_ADDRESS,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.SEPOLIA]: {
                address: ZERO_ADDRESS,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.OPTIMISM]: {
                address: ZERO_ADDRESS,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.BASE]: {
                address: ZERO_ADDRESS,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.MATIC]: {
                address: ZERO_ADDRESS,
                decimals: 18,
            },
        },
        name: 'ETH',
    },
    LOOKS: {
        coinGeckoId: 'looksrare',
        erc20: {
            [network_1.NETWORK_IDS.MAINNET]: {
                address: '0xf4d2888d29d722226fafa5d9b24f9164c092421e',
                decimals: 18,
            },
            [network_1.NETWORK_IDS.GOERLI]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.SEPOLIA]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.OPTIMISM]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.BASE]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.MATIC]: {
                address: undefined,
                decimals: 18,
            },
        },
        name: 'LOOKS',
    },
    PEPE: {
        coinGeckoId: 'pepe',
        erc20: {
            [network_1.NETWORK_IDS.MAINNET]: {
                address: '0x6982508145454ce325ddbe47a25d4ec3d2311933',
                decimals: 18,
            },
            [network_1.NETWORK_IDS.GOERLI]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.SEPOLIA]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.OPTIMISM]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.BASE]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.MATIC]: {
                address: undefined,
                decimals: 18,
            },
        },
        name: 'PEPE',
    },
    RARE: {
        coinGeckoId: 'superrare',
        erc20: {
            [network_1.NETWORK_IDS.MAINNET]: {
                address: '0xba5bde662c17e2adff1075610382b9b691296350',
                decimals: 18,
            },
            [network_1.NETWORK_IDS.GOERLI]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.SEPOLIA]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.OPTIMISM]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.BASE]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.MATIC]: {
                address: undefined,
                decimals: 18,
            },
        },
        name: 'RARE',
    },
    TURBO: {
        coinGeckoId: 'turbo',
        erc20: {
            [network_1.NETWORK_IDS.MAINNET]: {
                address: '0x4d224452801aced8b2f0aebe155379bb5d594381',
                decimals: 18,
            },
            [network_1.NETWORK_IDS.GOERLI]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.SEPOLIA]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.OPTIMISM]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.BASE]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.MATIC]: {
                address: undefined,
                decimals: 18,
            },
        },
        name: 'TURBO',
    },
    USDC: {
        coinGeckoId: 'usd-coin',
        erc20: {
            [network_1.NETWORK_IDS.MAINNET]: {
                address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
                decimals: 6,
            },
            [network_1.NETWORK_IDS.GOERLI]: {
                address: undefined,
                decimals: 6,
            },
            [network_1.NETWORK_IDS.SEPOLIA]: {
                address: undefined,
                decimals: 6,
            },
            [network_1.NETWORK_IDS.MATIC]: {
                address: undefined,
                decimals: 6,
            },
            [network_1.NETWORK_IDS.OPTIMISM]: {
                address: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
                decimals: 6,
            },
            [network_1.NETWORK_IDS.BASE]: {
                address: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
                decimals: 6,
            },
        },
        name: 'USDC',
    },
    USDT: {
        coinGeckoId: 'tether',
        erc20: {
            [network_1.NETWORK_IDS.MAINNET]: {
                address: '0xdac17f958d2ee523a2206206994597c13d831ec7',
                decimals: 6,
            },
            [network_1.NETWORK_IDS.GOERLI]: {
                address: undefined,
                decimals: 6,
            },
            [network_1.NETWORK_IDS.SEPOLIA]: {
                address: undefined,
                decimals: 6,
            },
            [network_1.NETWORK_IDS.MATIC]: {
                address: undefined,
                decimals: 6,
            },
            [network_1.NETWORK_IDS.OPTIMISM]: {
                address: '0x94b008aa00579c1307b0ef2c499ad98a8ce58e58',
                decimals: 6,
            },
            [network_1.NETWORK_IDS.BASE]: {
                address: undefined,
                decimals: 6,
            },
        },
        name: 'USDT',
    },
    WETH: {
        coinGeckoId: 'weth',
        erc20: {
            [network_1.NETWORK_IDS.MAINNET]: {
                address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                decimals: 18,
            },
            [network_1.NETWORK_IDS.GOERLI]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.SEPOLIA]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.MATIC]: {
                address: undefined,
                decimals: 18,
            },
            [network_1.NETWORK_IDS.OPTIMISM]: {
                address: '0x4200000000000000000000000000000000000006',
                decimals: 18,
            },
            [network_1.NETWORK_IDS.BASE]: {
                address: '0x4200000000000000000000000000000000000006',
                decimals: 18,
            },
        },
        name: 'WETH',
    },
};
/**
 * @dev returns a string representation of a number rounded to a given precision
 * @param value: the number to round
 * @param precision: the number of decimal places to round to
 * @returns a string representation of the rounded number (1234.56)
 */
function numberStringRound(value, precision) {
    return new decimal_js_1.Decimal(value).toFixed(precision, decimal_js_1.Decimal.ROUND_UP);
}
exports.numberStringRound = numberStringRound;
/**
 * @dev returns a string representation of a number rounded to a given precision, with commas
 * @param value: the number to round
 * @param precision: the number of decimal places to round to
 * @returns a string representation of the rounded number with commas (1,234.56)
 * @warn THIS HAS BUGS SEE TESTS, DO NOT USE THIS.
 */
function commifiedRoundedNumberString(value, precision) {
    return (0, units_1.commify)(numberStringRound(value, precision));
}
exports.commifiedRoundedNumberString = commifiedRoundedNumberString;
/**
 * @dev returns the colloquial ETH currency name/symbol for a given network
 * @param networkId: the network id
 * @returns the currency name (symbol, e.g. ETH or GoETH)
 * @throws if the network is not supported
 */
function ethCurrencyNameForNetwork(networkId) {
    switch (networkId) {
        case network_1.NETWORK_IDS.MAINNET:
            return 'ETH';
        case network_1.NETWORK_IDS.GOERLI:
            return 'GoETH';
        case network_1.NETWORK_IDS.OPTIMISM:
            return 'OETH';
        case network_1.NETWORK_IDS.BASE:
            return 'BETH';
        default:
            return 'ETH';
    }
}
exports.ethCurrencyNameForNetwork = ethCurrencyNameForNetwork;
/**
 * @dev returns the currency info for a given currency
 * @param currency: the currency's symbol as a string
 * @returns the currency info
 * @warn does not support network-specific ETH names (e.g. GoETH, BETH, OETH)
 * @throws if the currency is not supported
 * @example
 *   const theInfo = getCurrencyInfo('USDC');
 */
const getCurrencyInfo = (currency) => {
    const currencyInfo = currencies[currency];
    if (!currencyInfo) {
        throw new Error(`Currency ${currency} not supported`);
    }
    return currencyInfo;
};
exports.getCurrencyInfo = getCurrencyInfo;
const getCurrenciesOnNetwork = (networkId) => {
    const typedNetworkId = networkId;
    return Object.entries(currencies)
        .filter(([, info]) => info.erc20[typedNetworkId].address)
        .map(([currency]) => currency);
};
exports.getCurrenciesOnNetwork = getCurrenciesOnNetwork;
//# sourceMappingURL=currency.js.map